import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { colorMap, ColorNames } from '@/utils/constants';
import { INavigationDropdownItemProps } from '../../PortalNavigation.interfaces';

const useNavigationDropdownDividerStyles = makeStyles(
  ({ spacing }) => ({
    root: {
      borderBottom: `1px solid ${colorMap[ColorNames.mediumGray]}`,
      height: 0,
      margin: spacing(1, -2),
    },
  }),
  {
    name: 'NavigationDropdownDivider',
  },
);

const NavigationDropdownDivider = () => {
  const classes = useNavigationDropdownDividerStyles();
  return <div className={classes.root} />;
};

export const withNavigationDropdownDivider =
  (NavigationItemComponent: any) =>
  ({ children, ...restProps }: React.PropsWithChildren<INavigationDropdownItemProps>) => {
    const { navigationItem } = restProps;
    return navigationItem?.isDivider ? (
      <NavigationDropdownDivider />
    ) : (
      <NavigationItemComponent {...restProps}>{children}</NavigationItemComponent>
    );
  };

export default NavigationDropdownDivider;
